<template>

  <div class="d-flex flex-column align-items-center text-center pt-4 px-3 pb-3">

    <Avatar
      class="mb-3"
      :src="photo"
      :name="displayName"
      size="72px"
      radius="36px" />

    <div class="w-100">

      <template v-if="editing">
        <input
          ref="name"
          :value="name"
          type="text"
          class="form-control form-control-sm text-center"
          :placeholder="$t('Name')"
          :disabled="saving"
          @input="$emit('update:name', $event.target.value)"
          @keyup.enter="$emit('save')"
          @keyup.esc="$emit('cancel')">
        <div class="mt-2">
          <button
            type="button"
            class="btn btn-sm btn-light mr-2"
            :disabled="saving"
            @click="$emit('cancel')">{{ $t('Cancel') }}</button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            :disabled="saving"
            @click="$emit('save')">{{ $t('Save') }}</button>
        </div>
      </template>

      <div
        v-else
        class="d-inline-flex align-items-center justify-content-center mw-100">
        <h5 class="contact-header-name font-weight-bold mb-0">{{ displayName }}</h5>
        <button
          type="button"
          class="btn btn-link contact-header-edit text-muted ml-1 p-0"
          :title="$t('Edit contact')"
          @click="$emit('edit')">
          <i class="fa-solid fa-pen"></i>
        </button>
      </div>

    </div>

  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'ContactHeader',
  components: {
    Avatar
  },
  props: {
    conversation: {
      type: Object,
      default: null
    },
    editing: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  watch: {
    // o lápis some ao ser clicado, então o cursor tem que ir para o campo
    editing (editing) {
      if (editing) {
        this.$nextTick(() => {
          if (this.$refs.name) {
            this.$refs.name.focus()
          }
        })
      }
    }
  },
  computed: {
    displayName () {
      if (!this.conversation) {
        return ''
      }
      return this.conversation.name || this.conversation.contact_address || this.$t('No name')
    },
    /*
    photo
    a conversa não guarda foto: a única imagem é a do candidato associado. Sem
    candidato (ou com a foto padrão dele) o Avatar cai nas iniciais
    */
    photo () {
      const candidate = this.conversation && this.conversation.candidate_id
      const url = candidate && candidate.photo_media_url
      return url && !url.includes(config.default_image_url.candidate) ? url : null
    }
  }
}
</script>

<style scoped>
/* break long names instead of overflowing the panel */
.contact-header-name {
  word-break: break-word;
}

/* discreet next to the name, and only as big as the icon */
.contact-header-edit {
  font-size: 0.8rem;
  line-height: 1;
}
.contact-header-edit:hover {
  color: #495057 !important;
}
.contact-header-edit:focus:not(:focus-visible) {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/contact/ContactHeader.vue